export const termsAndConditionEnURL = 'https://studyo.co/tos';
export const privacyPolicyEnURL = 'https://studyo.co/privacy';

export const termsAndConditionFrURL = 'https://studyo.co/fr/tos';
export const privacyPolicyFrURL = 'https://studyo.co/fr/privacy';
